import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const BadgeContainer = styled.div(
	({ theme }) => css`
		background-color: #f02439;
		padding: 2px 6px;
		font-size: 12px;
		margin: 0px 3px;
		color: #fff;
		border-radius: 3px;
		font-weight: 700;
	`,
);
